import { render, staticRenderFns } from "./DjStudents.vue?vue&type=template&id=5cb6c5b2&scoped=true&lang=pug&"
import script from "./DjStudents.vue?vue&type=script&lang=ts&"
export * from "./DjStudents.vue?vue&type=script&lang=ts&"
import style0 from "./DjStudents.vue?vue&type=style&index=0&id=5cb6c5b2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb6c5b2",
  null
  
)

component.options.__file = "DjStudents.vue"
export default component.exports